var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-footer"},[_c('p',{staticClass:"copyright has-text-weight-bold has-text-grey"},[_vm._v(" © "+_vm._s(_vm.year)+" Gurkan Gul ")])])}
var staticRenderFns = []

export { render, staticRenderFns }